import type { DtsOutboundApiDto } from '@dhl/mdp-api'
import { presentDateOrDefault } from '~/modules/ppp/submodules/relations/utils'
import { DataRow, DataHeading } from '~/modules/ppp/submodules/relations/components/data'

type Props = {
  config: DtsOutboundApiDto
}
export const OutboundApi = ({ config }: Props) => (
  <>
    <DataHeading title="API" />
    <DataRow title="createdOn" payload={presentDateOrDefault(config.createdOn)} />
    <DataRow title="outName" payload={config.outName} withCopy />
    <DataRow title="outboundApi/baseUrl" payload={config.outboundApiSettings.baseUrl} withCopy />
    <DataRow title="outboundApi/usename" payload={config.outboundApiSettings.usename} withCopy />
  </>
)
